<template>
  <div class="signcontier">
    <el-form
      key="emailform"
      :model="ruleForms"
      ref="ruleForms"
      :rules="rules"
     :label-width="this.$i18n.locale=='en'?'250px':'150px'"
      class="demo-ruleForm"
    >
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('signphone.account')"
            prop="account"
          >
            <el-input
              v-model="ruleForms.account"
              class="inputsty"
              :placeholder="$t('signphone.accountText')"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('signphone.company')"
            prop="company"
          >
            <el-input
              v-model="ruleForms.company"
              :placeholder="$t('signphone.companyText')"
              class="inputsty"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('signphone.company_contact')"
            prop="company_contact"
          >
            <el-input
              v-model="ruleForms.company_contact"
              :placeholder="$t('signphone.company_contact_Text')"
              class="inputsty"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('signphone.password')"
            prop="passwords"
          >
            <el-input
              v-model="ruleForms.passwords"
              class="inputsty"
              type="password"
              :placeholder="$t('signphone.passwordText')"
              v-popover:popovers
            ></el-input>
            <el-popover
              ref="popovers"
              placement="right"
              width="30"
              trigger="focus"
              content=""
            >
              <p
                v-for="(item,it) in $t('signphone.popoversList')"
                :key="it"
              >
                {{item.name}}
              </p>
            </el-popover>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('signphone.rePasswords')"
            prop="rePasswords"
          >
            <el-input
              v-model="ruleForms.rePasswords"
              class="inputsty"
              type="password"
              :placeholder="$t('signphone.rePasswordsText')"
              v-popover:popoversr
            ></el-input>
            <el-popover
              ref="popoversr"
              placement="right"
              width="30"
              trigger="focus"
              content=""
            >
              <p>{{$t('signphone.popoversr')}}</p>
            </el-popover>
          </el-form-item>
        </div>
      </div>
      <div class="content">
        <div class="formLeft">
          <el-form-item
            :label="$t('signphone.email')"
            prop="emails"
          >
            <el-input
              v-model="ruleForms.emails"
              class="inputsty"
               :placeholder="$t('signphone.emailText')"
            ></el-input>
          </el-form-item>
        </div>
      </div>
      <div class="content posit">
        <div
          class="formLeft"
          style="height:40px;"
        >
          <drag-verify
            :width="316"
            :height="40"
            handlerIcon="el-icon-d-arrow-right"
            successIcon="el-icon-check"
             :text="$t('signphone.drag')"
           :success-text="$t('signphone.check')"
            background="#ddd"
            progress-bar-bg="#2ACBF8"
            text-size="14px"
            :circle="true"
            ref="Verify"
          >
          </drag-verify>
        </div>
      </div>
      <div
        style="color:red;"
        v-show="VerifyStatus"
      >{{$t('signphone.verifyStatus')}}</div>
      <div class="elbtn">
        <div
          class="titlecolor"
          style="margin-left:50px;cursor:pointer;"
        >
          <router-link
            target="_blank"
            :to="{ path: '/clause' }"
          ><span class="colorcur">{{$t('signphone.clause')}}</span></router-link>
          <span>&nbsp;&nbsp;&nbsp;</span>
          <router-link
            target="_blank"
            :to="{ path: '/privacy' }"
          ><span class="colorcur">{{$t('signphone.privacy')}}</span></router-link>
        </div>
        <div
          class="titlecolor"
          style="margin-top:5px;"
        >{{$t('signphone.care')}}</div>
        <el-button
          style="margin-top: 14px;width:316px;margin-left:50px;"
          @click="submits('ruleForms')"
          class="rightBtn"
          type="success"
          size="medium"
        >{{$t('signphone.agree')}}</el-button>
      </div>
    </el-form>

    <!-- 同意协议下一步 -->
    <el-dialog
      :visible.sync="changeDialogVisibles"
      :width="this.$i18n.locale=='en'?'38%':'34%'"
       :title="$t('signphone.checkemail')"
      center
      class="diaglogs"
    >
      <div style="margin-bottom:30px;">
         {{$t('signphone.nextEmail')}}{{
        reemail.replace(/(.{1}).+(.{2}@.+)/g, "$1****$2")
        }}
      </div>
      <el-form
        :model="digruleForms"
        ref="digruleForms"
        :rules="digrules"
         :label-width="this.$i18n.locale=='en'?'220px':'150px'"
        class="demo-ruleForm"
      >
        <div class="content">
          <div
            class="formLeft"
            style="float:left;"
          >
            <el-form-item
              :label="$t('signphone.emailcode')"
              prop="code"
            >
              <el-input
                v-model="digruleForms.code"
                class="picwid"
                :placeholder="$t('signphone.codetext')"
              ></el-input>
              <div
                class="codewid"
                style="margin-left:15px;"
              >
                <el-button
                  type="success"
                  @click="phonesendCodes"
                >{{
                  codeStrs
                  }}</el-button>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          type="success"
          @click="backlogin"
        >{{$t('signphone.submit')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dragVerify from "vue-drag-verify";
export default {
  props: {},
  components: {
    dragVerify
  },
  data() {
    var loginaccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('checkvalid.account')));
      }else {
        callback();
      }
    };
    var loginPass = (rule, value, callback) => {
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (
        !rest.test(value) ||
        !value ||
        value.length < 6 ||
        value.length > 20
      ) {
        return callback(new Error(this.$t('checkvalid.password')));
      } else {
        callback();
      }
    };
    var rePass = (rule, value, callback) => {
      var rest = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$).{6,}$/;
      if (
        !rest.test(value) ||
        !value ||
        value.length < 6 ||
        value.length > 20
      ) {
        return callback(new Error(this.$t('checkvalid.password')));
      } else if (value !== this.ruleForms.passwords) {
        callback(new Error(this.$t('checkvalid.same')));
      } else {
        callback();
      }
    };
    var emailvalids = (rule, value, callback) => {
      var rests = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (!rests.test(value) || value == 0) {
        return callback(new Error(this.$t('checkvalid.email')));
      } else {
        callback();
      }
    };
    return {
      ruleForms: {
        account: "",
        company: "",
        company_contact: "",
        passwords: "",
        rePasswords: "",
        emails: "",
        code: ""
      },
      rules: {
        account: [{ required: true, validator: loginaccount, trigger: "blur" }],
        company: [
          { required: true, message: this.$t('checkvalid.company'), trigger: "blur" }
        ],
        company_contact: [
          { required: true, message: this.$t('checkvalid.contact'), trigger: "blur" }
        ],
        passwords: [{ required: true, validator: loginPass, trigger: "blur" }],
        emails: [{ required: true, validator: emailvalids, trigger: "blur" }],
        code: [{ required: true, message: this.$t('checkvalid.code'), trigger: "blur" }],
        rePasswords: [{ required: true, validator: rePass, trigger: "blur" }]
      },
      changeDialogVisibles: false,
      digruleForms: {
        code: ""
      },
      reemail: "",
      digrules: {
        code: [{ required: true, message: this.$t('checkvalid.code'), trigger: "blur" }]
      },
      codeStrs: this.$t('forgectPhone.codeStr'),
      xyDialogVisible: false,
      cursor: true,
      VerifyStatus: false
    };
  },
  methods: {
    rulese() {
      this.$refs["ruleForms"].clearValidate();
    },
    submits(ruleForms) {
      this.$refs.ruleForms.validate(valid => {
        if (valid) {
          if (!this.$refs.Verify.isPassing) {
            this.VerifyStatus = true;
            return false;
          } else {
            this.VerifyStatus = false;
          }
          this.changeDialogVisibles = true;
          this.reemail = this.ruleForms.emails;
        } else {
          console.log("error submit!!");
          return;
        }
      });
    },
    phonesendCodes() {
      let that = this;
      let times = 60;
      // this.codeBinds();
      const data = {
        email: this.reemail
      };
      this.$http
        .post("/common/get_email_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t('checkvalid.codesuccess'),
                type: "success",
                duration: 1500
              });
              let timer = setInterval(() => {
                --times;
                that.codeStrs = times + "S";
                if (times == 0) {
                  this.codeStrs = this.$t('forgectPhone.codeStr');
                  clearInterval(timer);
                }
              }, 1000);
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    codeBinds() {
      const data = {
        email: this.reemail
      };
      this.$http
        .post("/common/get_email_code", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.$message({
                message: this.$t('checkvalid.codesuccess'),
                type: "success",
                duration: 1500
              });
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    userInfo() {
      const data = {
        token: this.$store.state.token
      };
      this.$http
        .post("/user/get_me", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              // 先进行本地存储
              console.log(res.data);
              this.$store.state.userName = res.data.data.name;
              window.sessionStorage.setItem("userName", res.data.data.name);
              this.$router.push({
                name: "main"
              });
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    backlogin() {
      this.changeDialogVisible = false;
      const data = {
        name: this.ruleForms.account,
        company_name: this.ruleForms.company,
        password: this.ruleForms.passwords,
        email: this.reemail,
        code: this.digruleForms.code,
        company_contact: this.ruleForms.company_contact
      };
      this.$http
        .post("/login/email_register", data)
        .then(res => {
          console.log(res);
          if (res.status == 200) {
            if (res.data.status == 0) {
              // 先进行本地存储
              console.log(res.data);
              // this.$store.commit(loginIn, res.data.token);
              this.$store.state.token = res.data.data.token;
              window.sessionStorage.setItem("token", res.data.data.token);
              this.$message({
                message: this.$t('checkvalid.logins'),
                type: "success",
                duration: 1000
              });
              this.userInfo();
            } else {
              this.$message({
                message: res.data.error,
                type: "warning",
                duration: 1500
              });
              return;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="scss">
.signemail {
  .diaglogs {
    .el-form-item__label {
      padding-right: 24px;
    }
  }
}
</style>
